import type { RootState } from "@src/store/rootState";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getEmbeddedNodeFactory } from "@src/store/slices/experienceBuilder/common/selectors/getEmbeddedNodeFactory";

export const getOriginalSrcFactory = (mod: EmbeddedMod) => {
  const getEmbeddedNode = getEmbeddedNodeFactory(mod);
  return (state: RootState) => {
    const node = getEmbeddedNode(state);
    if (!node) return "";

    if ("src" in node) {
      return node.src ?? "";
    }
    return "";
  };
};
